import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import DatePicker from "react-date-picker";

import {
  OverlayTrigger,
  InputGroup,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class AccountLedger extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dateRange: "This Month",
      fromDate: "",
      toDate: "",
      // initialize ledgerSummary with zeroed fields to avoid render errors
      ledgerSummary: {
        totalSalesRevenue: 0,
        totalOtherRevenue: 0,
        totalProductPurchases: 0,
        totalRawmaterialPurchases: 0,
        totalOtherExpenses: 0,
        totalSalaries: 0,
        accountReceiveable: 0,
        accountPayable: 0,
      },
      loadSpinnerOpen: false,
    };
  }
  printRef = React.createRef();

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  // helper: format Date -> YYYY-MM-DD
  fmt = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${dd}`;
  };

  // helper: calculate start & end for Today/Yesterday/This Week/Last Week (week start = Monday)
  calcRange = (rangeKey) => {
    const today = new Date();
    const zero = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

    if (rangeKey === "Today") {
      const t = zero(today);
      return { from: this.fmt(t), to: this.fmt(t) };
    }
    if (rangeKey === "Yesterday") {
      const y = zero(
        new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1)
      );
      return { from: this.fmt(y), to: this.fmt(y) };
    }
    if (rangeKey === "This Week") {
      const t = zero(today);
      const day = t.getDay(); // 0=Sun,1=Mon...
      const diffToMon = day === 0 ? -6 : 1 - day; // if Sunday go back 6 days
      const mon = new Date(
        t.getFullYear(),
        t.getMonth(),
        t.getDate() + diffToMon
      );
      const sun = new Date(
        mon.getFullYear(),
        mon.getMonth(),
        mon.getDate() + 6
      );
      return { from: this.fmt(mon), to: this.fmt(sun) };
    }
    if (rangeKey === "Last Week") {
      const t = zero(today);
      const day = t.getDay();
      const diffToMon = day === 0 ? -6 : 1 - day;
      const thisMon = new Date(
        t.getFullYear(),
        t.getMonth(),
        t.getDate() + diffToMon
      );
      const lastMon = new Date(
        thisMon.getFullYear(),
        thisMon.getMonth(),
        thisMon.getDate() - 7
      );
      const lastSun = new Date(
        lastMon.getFullYear(),
        lastMon.getMonth(),
        lastMon.getDate() + 6
      );
      return { from: this.fmt(lastMon), to: this.fmt(lastSun) };
    }

    // null means use original named range (This Month / Last Month / This Year / Last Year)
    return null;
  };

  printReport = () => {
    const s = this.state.ledgerSummary || {};

    const totalA =
      Number(s.totalSalesRevenue || 0) + Number(s.totalOtherRevenue || 0);

    const totalB =
      Number(s.totalProductPurchases || 0) +
      Number(s.totalRawmaterialPurchases || 0) +
      Number(s.totalOtherExpenses || 0) +
      Number(s.totalSalaries || 0);

    const settings = this.context.storeSettings || {};
    const storeName = settings.storeName || "";
    const storeAddress = settings.storeAddress || "";
    const storeEmail = settings.storeEmailId || "";
    const storePhone = settings.storePhoneNo || "";

    const dateText = this.context.GetDateResult(
      this.state.dateRange,
      new Date(this.state.fromDate),
      new Date(this.state.toDate)
    );

    const win = window.open("", "", "width=900,height=800");

    win.document.write(`
    <html>
    <head>
      <title>Account Ledger Summary</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 20px;
          font-size: 13px;
        }
        h2, h3 {
          margin: 4px 0;
          text-align: center;
        }
        .header {
          text-align: center;
          margin-bottom: 10px;
        }
        .header small {
          display: block;
          font-size: 11px;
        }
        hr {
          margin: 8px 0;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        td {
          padding: 4px 6px;
          vertical-align: top;
        }
        .amount {
          text-align: right;
          white-space: nowrap;
        }
        .section-title {
          font-weight: bold;
          text-align: center;
          padding: 6px 0;
        }
        .subtotal {
          font-weight: bold;
          border-top: 1px solid #000;
        }
        .balance {
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          padding: 10px 0;
          border-top: 2px solid #000;
          border-bottom: 2px solid #000;
          margin: 10px 0;
        }
      </style>
    </head>
    <body>

      <div class="header">
        <h3>${storeName}</h3>
        <small>${storeAddress}</small>
        <small>${storeEmail} ${storePhone ? " | " + storePhone : ""}</small>
        <small><b>${dateText}</b></small>
      </div>

      <hr>

      <h3>Account Ledger Summary</h3>

      <table>
        <tr>
          <td width="50%">
            <div class="section-title">CREDITS</div>
            <table>
              <tr>
                <td>Sales Revenue</td>
                <td class="amount">${this.renderNumber(
                  s.totalSalesRevenue
                )}</td>
              </tr>
              <tr>
                <td>Other Credits</td>
                <td class="amount">${this.renderNumber(
                  s.totalOtherRevenue
                )}</td>
              </tr>
              <tr class="subtotal">
                <td>Sub.Total (A)</td>
                <td class="amount">${this.renderNumber(totalA)}</td>
              </tr>
            </table>
          </td>

          <td width="50%">
            <div class="section-title">DEBITS</div>
            <table>
              <tr>
                <td>Product Purchases</td>
                <td class="amount">${this.renderNumber(
                  s.totalProductPurchases
                )}</td>
              </tr>
              <tr>
                <td>Rawmaterial Purchases</td>
                <td class="amount">${this.renderNumber(
                  s.totalRawmaterialPurchases
                )}</td>
              </tr>
              <tr>
                <td>Other Expenses</td>
                <td class="amount">${this.renderNumber(
                  s.totalOtherExpenses
                )}</td>
              </tr>
              <tr>
                <td>Employee Salaries</td>
                <td class="amount">${Number(
                  this.renderNumber(s.totalSalaries)
                ).toFixed(0)}</td>
              </tr>
              <tr class="subtotal">
                <td>Sub.Total (B)</td>
                <td class="amount">${Number(this.renderNumber(totalB)).toFixed(
                  0
                )}</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

      <div class="balance">
        Balance (A - B) : ${Number(this.renderNumber(totalA - totalB)).toFixed(
          0
        )}
      </div>

      <table>
        <tr>
          <td>Total Account Receivables</td>
          <td class="amount">${this.renderNumber(s.accountReceiveable)}</td>
          <td>Total Account Payables</td>
          <td class="amount">${this.renderNumber(s.accountPayable)}</td>
        </tr>
      </table>

    </body>
    </html>
  `);

    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  GetLedgerSummary = () => {
    this.ShowLoadSpinner();

    // const rangeKey = this.state.dateRange;
    // const calc = this.calcRange(rangeKey);
    // const dateRangeParam = calc
    //   ? encodeURIComponent(`${calc.from}_${calc.to}`)
    //   : encodeURIComponent(rangeKey);

    const rangeKey = this.state.dateRange;
    const calc = this.calcRange(rangeKey);

    let dateRangeParam;

    if (rangeKey === "Custom" && this.state.fromDate && this.state.toDate) {
      dateRangeParam = `${this.state.fromDate}_${this.state.toDate}`;
    } else if (calc) {
      dateRangeParam = `${calc.from}_${calc.to}`;
    } else {
      dateRangeParam = rangeKey;
    }

    const url =
      process.env.REACT_APP_API +
      "Account/GetLedgerSummary/" +
      this.context.storeId +
      "/" +
      dateRangeParam;

    // robust parsing for responses that may be JSON-stringified on server
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        let parsed;
        try {
          parsed = text ? JSON.parse(text) : null;
        } catch (e) {
          // if parsing fails, keep raw text
          parsed = text;
        }

        // if server returns an object with status 400
        if (parsed && parsed.status == 400) {
          // handle the 400 case if you want (kept the original behavior)
          this.HideLoadSpinner();
        } else {
          // if parsed is a string (unexpected), try second parse; otherwise set ledgerSummary
          if (typeof parsed === "string") {
            try {
              const doubleParsed = JSON.parse(parsed);
              this.setState({ ledgerSummary: doubleParsed }, () => {});
            } catch (e) {
              // not JSON — clear or ignore
              this.setState({ ledgerSummary: {} });
            }
          } else if (!parsed) {
            // no data -> empty
            this.setState({
              ledgerSummary: {
                totalSalesRevenue: 0,
                totalOtherRevenue: 0,
                totalProductPurchases: 0,
                totalRawmaterialPurchases: 0,
                totalOtherExpenses: 0,
                totalSalaries: 0,
                accountReceiveable: 0,
                accountPayable: 0,
              },
            });
          } else {
            this.setState({ ledgerSummary: parsed }, () => {});
          }
          this.HideLoadSpinner();
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
      });
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.GetLedgerSummary();
  };

  renderNumber = (v) => {
    const n = Number(v || 0);
    return n.toFixed(2);
  };

  render() {
    const s = this.state.ledgerSummary || {};
    const totalA =
      Number(s.totalSalesRevenue || 0) + Number(s.totalOtherRevenue || 0);
    const totalB =
      Number(s.totalProductPurchases || 0) +
      Number(s.totalRawmaterialPurchases || 0) +
      Number(s.totalOtherExpenses || 0) +
      Number(s.totalSalaries || 0);

    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}

          {this.props.isReport != true ? (
            <>
              <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
                <h3>
                  {" "}
                  <b>Account Ledger</b> &nbsp;
                </h3>
              </Navbar>
            </>
          ) : (
            <></>
          )}
          <div className="purposestyle p-2 ">
            {" "}
            <b>Purpose:</b> This is a Ledger Module(Balance Sheet) which gives
            you a summary of all Debit/Credit transactions in the Business
            Account. You would be able to see the summary of all transactions in
            the current month, last month, current year, and last Year. The
            Ledger Summary will be derived from all Debit/Credit transactions.
          </div>
          <div className="bg-light ">
            <Table className="bg-light m-0 p-0">
              <tbody>
                <tr className="border-0">
                  <td width="40%">
                    <InputGroup className="mb-1">
                      <InputGroup.Text id="basic-addon1">
                        Date Range
                      </InputGroup.Text>
                      <Form.Select
                        value={this.state.dateRange}
                        onChange={(e) => {
                          this.setState({ dateRange: e.target.value }, () => {
                            if (e.target.value !== "Custom") {
                              this.GetLedgerSummary();
                            }
                          });
                        }}
                      >
                        <option value="Today">Today</option>
                        <option value="Yesterday">Yesterday</option>
                        <option value="This Week">This Week</option>
                        <option value="Last Week">Last Week</option>
                        <option value="This Month">This Month</option>
                        <option value="Last Month">Last Month</option>
                        <option value="This Year">This Year</option>
                        <option value="Last Year">Last Year</option>
                        <option value="Custom">Custom</option>
                      </Form.Select>
                    </InputGroup>
                    {this.state.dateRange === "Custom" && (
                      <Row className="mb-2 align-items-end">
                        <Col md={4}>
                          <Form.Label className="small">From</Form.Label>
                          <Form.Control
                            type="date"
                            className="w-100"
                            value={this.state.fromDate}
                            onChange={(e) =>
                              this.setState({ fromDate: e.target.value })
                            }
                          />
                        </Col>

                        <Col md={4}>
                          <Form.Label className="small">To</Form.Label>
                          <Form.Control
                            type="date"
                            className="w-100"
                            value={this.state.toDate}
                            onChange={(e) =>
                              this.setState({ toDate: e.target.value })
                            }
                          />
                        </Col>

                        <Col md={4}>
                          <Button
                            variant="primary"
                            className="w-100"
                            onClick={this.GetLedgerSummary}
                            disabled={
                              !this.state.fromDate || !this.state.toDate
                            }
                          >
                            Apply
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </td>
                  <td className="text-end">
                    <Button
                      variant="outline-secondary"
                      disabled={
                        this.state.dateRange === "Custom" &&
                        (!this.state.fromDate || !this.state.toDate)
                      }
                      onClick={this.printReport}
                    >
                      🖨️ Print Report
                    </Button>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className="bg-light p-5" ref={this.printRef}>
            <Row>
              <Col xs={6} className="border">
                <h2 className="text-center">CREDITS</h2>
                <Row>
                  <Col>
                    <h4>Sales Revenue</h4>
                  </Col>
                  <Col>
                    <h4 className="text-end">
                      {Number(this.renderNumber(s.totalSalesRevenue)).toFixed(
                        0
                      )}
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <h4>Other Credits</h4>
                  </Col>
                  <Col>
                    <h4 className="text-end">
                      {Number(this.renderNumber(s.totalOtherRevenue)).toFixed(
                        0
                      )}
                    </h4>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col>
                    <h4>
                      <b>Sub.Total (A):</b>
                    </h4>
                  </Col>
                  <Col>
                    <h4 className="text-end">
                      <b>{Number(this.renderNumber(totalA)).toFixed(0)}</b>
                    </h4>
                  </Col>
                </Row>
              </Col>
              <Col xs={6} className="border">
                <h2 className="text-center">DEBITS</h2>
                <Row>
                  <Col>
                    <h4>Product Purchases</h4>
                  </Col>
                  <Col>
                    <h4 className="text-end">
                      {Number(
                        this.renderNumber(s.totalProductPurchases)
                      ).toFixed(0)}
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <h4>Rawmaterial Purchases</h4>
                  </Col>
                  <Col>
                    <h4 className="text-end">
                      {Number(
                        this.renderNumber(s.totalRawmaterialPurchases)
                      ).toFixed(0)}
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <h4>Other Expenses</h4>
                  </Col>
                  <Col>
                    <h4 className="text-end">
                      {Number(this.renderNumber(s.totalOtherExpenses)).toFixed(
                        0
                      )}
                    </h4>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <h4>Employee Salaries</h4>
                  </Col>
                  <Col>
                    <h4 className="text-end">
                      {Number(this.renderNumber(s.totalSalaries)).toFixed(0)}
                    </h4>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col>
                    <h4>
                      <b>Sub.Total (B):</b>
                    </h4>
                  </Col>
                  <Col>
                    <h4 className="text-end">
                      <b>{Number(this.renderNumber(totalB)).toFixed(0)}</b>
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="py-3  border">
              <Col className="text-center">
                <h1>
                  <b>
                    Balance (A-B) :{" "}
                    {Number(this.renderNumber(totalA - totalB)).toFixed(0)}{" "}
                  </b>
                </h1>
              </Col>
            </Row>
            <Row>
              <Col>
                <h4>Total Account Receivables:</h4>
              </Col>
              <Col>
                <h4 className="text-end">
                  {Number(this.renderNumber(s.accountReceiveable)).toFixed(0)}
                </h4>
              </Col>
              <Col>
                <h4>Total Account Payables:</h4>
              </Col>
              <Col>
                <h4 className="text-end">
                  {Number(this.renderNumber(s.accountPayable)).toFixed(0)}
                </h4>
              </Col>
            </Row>
          </div>
        </div>
      </>
    );
  }
}
